import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "projectDescription",
    standalone: false,
})
export class ProjectDescriptionPipe implements PipeTransform {
    transform(description: string, length = 100): any {
        if (!description) {
            return "";
        }
        if (description.length < length) {
            return description;
        }

        return `${description.slice(0, length)}...`;
    }
}
